import React from "react";

export default function ProjectViewReport() {
  return <div style={{ border: "2px solid black", borderRadius: "5px" }}>REPORT</div>;
}
